/**
 * 环境配置工具
 * 统一读取 Vite 注入的环境变量，供应用各处使用。
 */
export const ENV = {
  /** 当前环境标识 */
  mode: import.meta.env.VITE_APP_ENV,
  /** 应用标题 */
  title: import.meta.env.VITE_APP_TITLE,
  /** 公司名称（ICP 备案主体） */
  companyName: import.meta.env.VITE_COMPANY_NAME,
  /** 统一社会信用代码 */
  creditCode: import.meta.env.VITE_CREDIT_CODE,
  /** ICP 备案号（按部署域名不同而不同） */
  icpNo: import.meta.env.VITE_ICP_NO,
  /** ICP 备案对应的网站域名 */
  icpDomain: import.meta.env.VITE_ICP_DOMAIN,
  /** API 基础地址 */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  /** 部署基础路径 */
  basePath: import.meta.env.VITE_APP_BASE_PATH,
} as const

/** 工信部 ICP 备案信息查询系统链接 */
export const ICP_BEIAN_URL = 'https://beian.miit.gov.cn/'

/** 是否为开发模式 */
export const isDev = import.meta.env.DEV
/** 是否为生产构建 */
export const isProd = import.meta.env.PROD

/** 是否为本地环境 */
export const isLocal = ENV.mode === 'local'
/** 是否为测试环境 */
export const isTest = ENV.mode === 'test'
/** 是否为预发布环境 */
export const isPrv = ENV.mode === 'prv'

/** 环境展示名称（用于页脚/角标） */
export const ENV_LABEL: Record<string, string> = {
  local: '本地环境',
  test: '测试环境',
  prv: '预发布',
  prod: '生产环境',
}
